import { getReportLinkSlug } from "./get-report-link-slug.js";
import { getReportLinkViewerPath } from "./get-report-link-viewer-path.js";

/**
 * Converte report-link (modelo UI) em item de submenu da sidebar.
 * @param {Object} reportLink
 * @returns {Object}
 */
export function mapReportLinkToSidebarMenuItem(reportLink) {
  const slug = getReportLinkSlug(reportLink.name);

  return {
    label: reportLink.name,
    id: `report-link-${slug}`,
    href: getReportLinkViewerPath(reportLink.name),
    description: reportLink.name,
    action: "islist",
  };
}
